import { render, staticRenderFns } from "./MatchColumns.vue?vue&type=template&id=0d8ec5df&"
import script from "./MatchColumns.vue?vue&type=script&lang=js&"
export * from "./MatchColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8ec5df')) {
      api.createRecord('0d8ec5df', component.options)
    } else {
      api.reload('0d8ec5df', component.options)
    }
    module.hot.accept("./MatchColumns.vue?vue&type=template&id=0d8ec5df&", function () {
      api.rerender('0d8ec5df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/Steps/MatchColumns.vue"
export default component.exports